@import '~style-sheet-helpers/core.less';
@import '../../../app-brand/entities/entity-layer.module.less';

.edit-filterview-modal {
  width: 400px;
  min-height: auto;
}

.modal-body {
  padding: 10px;
  overflow: auto;
}

.modal-content {
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  min-height: 100px;
}

.error-wrapper {
  display: flex;
  flex-direction: row;
  padding: 10px;
  background: @edit-filterview-modal--background-color;
}

.error-details {
  font-size: 13px;
  padding-left: 10px;
  margin: auto;
}

.error {
  display: flex;
  flex-direction: row;
  border-right: 1px solid @edit-filterview-modal--border-color;
  align-items: center;

  svg {
    height: 35px;
    width: 35px;
    transform: scale(0.5);
    fill: @edit-filterview-modal--fill-color;
  }

  .error-message {
    flex: 1;
    font-size: 16px;
    color: @edit-filterview-modal--text-color;
    padding-right: 10px;
  }
}

.modal-footer {
  div {
    float: left;
    font-size: 12px;
    .footer-content-left {
      background: none;
      border: none;
      color: @edit-filterview-modal--text-color;
      cursor: pointer;
      padding: 0;
      margin: 0;
    }
  }
  > button {
    margin-left: 10px;
  }
}
